export { default } from './InputBase';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/InputBase/index.js
// module id = 269
// module chunks = 2